import React from "react";

const weekdayLabels = {
  lunes: "Lunes",
  martes: "Martes",
  miercoles: "Miércoles",
  jueves: "Jueves",
  viernes: "Viernes",
  sabado: "Sábado",
  domingo: "Domingo",
};

const InfoRow = ({ label, children }) => (
  <div className="actividad-info-row">
    <div className="actividad-info-label"><strong>{label}:</strong></div>
    <div className="actividad-info-data">{children || "-----"}</div>
  </div>
);

const formatTime = (value) => value?.slice(0, 5) || "-----";
const formatPrice = (value) => {
  if (value === null || value === undefined || value === "") return null;
  if (Number(value) === 0) return "Gratuito";
  return new Intl.NumberFormat("es-CL", {
    style: "currency", currency: "CLP", maximumFractionDigits: 0,
  }).format(Number(value));
};

const SeccionGeneral = ({ iniciativa }) => {
  if (!iniciativa) return <div>Cargando...</div>;

  const weekdays = (iniciativa.dias_semana || [])
    .map((weekday) => weekdayLabels[weekday])
    .filter(Boolean)
    .join(", ");
  const requirements = (iniciativa.requisitos || "")
    .split(/\r?\n/)
    .map((item) => item.replace(/^\s*[•*-]\s*/, "").trim())
    .filter(Boolean);

  return (
    <div className="actividad-info initiative-general-info">
      <div className="initiative-section-heading">
        <div><span>RESUMEN</span><h5>Información general</h5><p>Datos principales de planificación y ejecución.</p></div>
      </div>
      <div className="initiative-general-grid">
      <InfoRow label="Fecha de Inicio">{iniciativa.f_inicio}</InfoRow>
      <InfoRow label="Fecha de Término">{iniciativa.f_termino}</InfoRow>
      <InfoRow label="Horario">
        {iniciativa.hora_inicio
          ? `${formatTime(iniciativa.hora_inicio)}${iniciativa.hora_termino ? ` a ${formatTime(iniciativa.hora_termino)}` : ""}`
          : null}
      </InfoRow>
      <InfoRow label="Días de realización">{weekdays || null}</InfoRow>
      <InfoRow label="Formato">{iniciativa.formato}</InfoRow>
      <InfoRow label="Lugar">{iniciativa.lugar}</InfoRow>
      <InfoRow label="Precio">{formatPrice(iniciativa.precio)}</InfoRow>
      <InfoRow label="Precio preferencial">{formatPrice(iniciativa.precio_preferencial)}</InfoRow>
      <InfoRow label="Cupos">{iniciativa.cupos}</InfoRow>
      <InfoRow label="Coffee break">{iniciativa.comida === "si" ? "Sí" : iniciativa.comida === "no" ? "No" : null}</InfoRow>
      <InfoRow label="Capacitación">{iniciativa.horas_c ? `${iniciativa.horas_c} hrs` : null}</InfoRow>
      <InfoRow label="Talleres">{iniciativa.horas_t ? `${iniciativa.horas_t} hrs` : null}</InfoRow>
      <InfoRow label="Act. Extraprogramáticas">{iniciativa.horas_e ? `${iniciativa.horas_e} hrs` : null}</InfoRow>
      </div>
      <div className="initiative-requirements">
        <strong>Requisitos de participación</strong>
        {requirements.length ? <ul>{requirements.map((item, index) => <li key={`${item}-${index}`}>{item}</li>)}</ul> : <p>Sin requisitos informados.</p>}
      </div>
    </div>
  );
};

export default SeccionGeneral;
